export default function Footer() {
  return (
    <footer className="bg-[#050810] border-t border-[#1E2A3A] py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C9A84C] rounded-sm">
                <span className="text-[#0A0F1A] font-black text-lg" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>YX</span>
              </div>
              <div>
                <div className="text-white font-bold text-sm tracking-widest uppercase">YAXIN LIANPEI</div>
                <div className="text-[#C9A84C] text-[10px] tracking-[0.2em] uppercase">ООО ЯСИН РУС · Since 1994</div>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-sm mb-6">
              30 лет экспорта автозапчастей BMW, VAG, JLR из Китая. Белая таможня, ГТД/НДС, Честный ЗНАК. EAC сертификация. Масла Shell из Гонконга.
            </p>
            <div className="flex flex-wrap gap-2">
              {["Белая таможня", "ГТД/НДС", "Честный ЗНАК", "EAC"].map((tag) => (
                <span key={tag} className="text-[#C9A84C] text-[10px] font-semibold bg-[#C9A84C]/10 border border-[#C9A84C]/20 px-2 py-0.5 rounded-sm whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <div className="text-white font-semibold text-sm uppercase tracking-widest mb-4">Навигация</div>
            <div className="flex flex-col gap-2.5">
              {[
                { label: "О компании", href: "#about" },
                { label: "Матрица ТО", href: "#matrix" },
                { label: "Масла Shell", href: "#shell" },
                { label: "Логистика", href: "#logistics" },
                { label: "Контакты", href: "#contact" },
              ].map((link) => (
                <a key={link.label} href={link.href} className="text-gray-500 hover:text-[#C9A84C] text-sm transition-colors cursor-pointer">
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Entities */}
          <div>
            <div className="text-white font-semibold text-sm uppercase tracking-widest mb-4">Юридические лица</div>
            <div className="flex flex-col gap-4">
              <div>
                <div className="text-[#C9A84C] text-xs font-semibold mb-0.5">YAXIN LIANPEI</div>
                <div className="text-gray-500 text-xs">КНР · Гуанчжоу</div>
              </div>
              <div>
                <div className="text-[#C9A84C] text-xs font-semibold mb-0.5">GUANGZHOU CHIRUN</div>
                <div className="text-gray-500 text-xs">КНР · Экспорт и логистика</div>
              </div>
              <div>
                <div className="text-[#C9A84C] text-xs font-semibold mb-0.5">ООО «ЯСИН РУС»</div>
                <div className="text-gray-500 text-xs">Россия · Москва · EAC заявитель</div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1E2A3A] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-gray-600 text-xs">
            © 2026 YAXIN LIANPEI / ООО «ЯСИН РУС». Все права защищены.
          </div>
          <div className="text-gray-600 text-xs text-center sm:text-right">
            Белая таможня · ГТД/НДС · Честный ЗНАК · EAC · BMW · VAG · JLR · Shell HK
          </div>
        </div>
      </div>
    </footer>
  );
}
